var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"app-list"},_vm._l((_vm.items),function(item,idx){return _c('li',{key:idx,staticClass:"app-list__item"},[_vm._t("item-content",null,{"currentItem":item,"currentIndex":idx,"items":_vm.items})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }